import { Link } from "react-router-dom";
import { CATEGORY_LABELS } from "@/lib/format";

export function Meistgelesen({ articles }) {
  return (
    <aside data-testid="sidebar-meistgelesen" className="bg-white border border-edborder">
      <div className="bg-prussian px-4 py-3">
        <h2 className="font-headline font-bold text-white text-lg tracking-tight">Meistgelesen</h2>
      </div>
      <ol className="divide-y divide-edborder">
        {articles.map((a, i) => (
          <li key={a.id} className="group">
            <Link to={`/artikel/${a.slug}`} className="flex gap-3 px-4 py-4 hover:bg-offwhite transition-colors">
              <span className="font-headline font-black text-3xl text-gold leading-none w-8 shrink-0">{i + 1}</span>
              <div>
                <span className="text-[10px] uppercase tracking-wider text-muted-foreground font-body">
                  {CATEGORY_LABELS[a.category]}
                </span>
                <h3 className="font-headline font-semibold text-prussian text-[15px] leading-snug group-hover:text-gold-hover transition-colors line-clamp-3">
                  {a.title}
                </h3>
              </div>
            </Link>
          </li>
        ))}
      </ol>
    </aside>
  );
}
